import { useQuery } from 'react-query';

import { getProgressPreferences as queryFn } from 'api/endPoints/getProgressPreferences';

import { TBaselineComparable } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/ProjectPreferences/ProjectPreferences.utils';

export interface IGetProgressPreferencesResponse {
    name: TBaselineComparable;
    value: 'planned_finish' | 'calculated_finish_date';
    isSelectedOption: boolean;
}

export const useQueryGetProgressPreferences = ({ projectId }) => {
    return useQuery<IGetProgressPreferencesResponse[], QueryError>(
        ['useQueryGetProgressPreferences', projectId],
        () => queryFn(projectId),
        {
            enabled: Boolean(projectId),
        },
    );
};
